import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FulfillService } from '@pages/workspace/fulfill/fulfill.service';
import { OrderUpdateCase } from '@pages/workspace/fulfill/utils/models';
import { getOrderSplitIndicesString } from '@utils/order-split-utils';

@Component({
  selector: 'multiple-fulfillment-dialog',
  templateUrl: './multiple-fulfillment.dialog.html',
  styleUrls: ['./multiple-fulfillment.dialog.scss'],
  standalone: false,
})
export class MultipleFulfillmentDialog implements OnInit {
  @Output() onFulfill = new EventEmitter();
  @Output() onPick = new EventEmitter();
  updateIssueMessage: string = `This following orders must be synced before this bulk action: `;
  disableAction: boolean = false;
  orders: any;
  isLoading: boolean = false;
  isPickingMode: boolean = false;
  label: string = 'Mark as fulfilled';

  constructor(
    public dialogRef: MatDialogRef<MultipleFulfillmentDialog>,
    private fulfillService: FulfillService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.orders = this.data.orders;
    if (this.data.isPickingMode) {
      this.isPickingMode = this.data.isPickingMode;
      this.label = 'Mark as picked';
    }
    this.fulfillService.onLoading.subscribe((loading) => {
      this.isLoading = loading;
    });

    this.updateOrdersIssue();
  }

  updateOrdersIssue() {
    const updatedOrdersSyncAction = this.orders.filter(
      (o) =>
        o.updateType?.includes(OrderUpdateCase.LINE_ITEMS_CHANGED) ||
        o.updateTypeV2?.includes(OrderUpdateCase.LINE_ITEMS_LOCATION_CHANGED),
    );

    if (updatedOrdersSyncAction?.length > 0) {
      this.disableAction = true;
      const orderNumbers = updatedOrdersSyncAction.map((o) =>
        o.splitted ? `${o.orderNumber}${getOrderSplitIndicesString(o, 'view', true)}` : o.orderNumber,
      );
      this.updateIssueMessage += orderNumbers.join(' , ');
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  approveButton(): void {
    if (this.isPickingMode) {
      this.onPick.emit();
    } else {
      this.onFulfill.emit();
    }
  }
}
